import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconComputerUse: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="computer-use, cursor"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M11 16L8 8L16 11L12.5 12.5L11 16Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconComputerUse;
